import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {Dispatch, SetStateAction, useEffect} from "react";
import {ChevronLeft, ChevronRight} from 'react-bootstrap-icons';
import './Pager.scss'

interface PagerProps {
    itemCount : number
    currentPage : number
    setCurrentPage? : Dispatch<SetStateAction<number>>
    maxItemsPerPage : number
}

export const Pager = ({itemCount, currentPage, setCurrentPage, maxItemsPerPage} : PagerProps) =>
{
    const nrOfPages = Math.max(1, Math.ceil(itemCount / maxItemsPerPage));
    const {t} = useTranslationWithOverride();

    useEffect(() =>
    {
        if (setCurrentPage !== undefined && currentPage > nrOfPages) {
            setCurrentPage(nrOfPages);
        }
    }, [currentPage, nrOfPages, setCurrentPage]);

    const onChangePage = (newPage: number) =>
    {
        if (newPage < 1 || newPage > nrOfPages) return;
        if (setCurrentPage !== undefined) {
            setCurrentPage(newPage);
        }
    }

    const page = Math.min(currentPage, nrOfPages);

    return (
        <div className="cm-pager">
            <button
                className="cm-pager-btn"
                onClick={() => onChangePage(page - 1)}
                disabled={page === 1}
                aria-label={t("pager.previous")}
            >
                <ChevronLeft />
            </button>
            <span className="cm-pager-label">{page} / {nrOfPages}</span>
            <button
                className="cm-pager-btn"
                onClick={() => onChangePage(page + 1)}
                disabled={page === nrOfPages}
                aria-label={t("pager.next")}
            >
                <ChevronRight />
            </button>
        </div>
    );
}
